<template>
    <div class="Navbar flex flex-j-c-sa">
        <div class="Navbar-item" @click="navChange(index)" v-for="(item, index) in selecteData" :key="index">
            <p :class="selected === index ? 'text-black': ''">{{item.name}}<span v-if="item.num !== 0">({{item.num}})</span></p>
            <div :class="selected === index ? 'item-line': ''"></div>
        </div>
        <!-- <div class="Navbar-item" @click="navChange('2')">
            <p>二级(10)</p>
            <div :class="selected === '2' ? 'item-line': ''"></div>
        </div>
        <div class="Navbar-item" @click="navChange('3')">
            <p>未审核(99+)</p>
            <div :class="selected === '3' ? 'item-line': ''"></div>
        </div>
        <div class="Navbar-item" @click="navChange('4')">
            <p>未审核(99+)</p>
            <div :class="selected === '4' ? 'item-line': ''"></div>
        </div> -->
    </div>
</template>

<script>

export default {
  name: 'Navbar',
  props: {
    selected: Number,
    selecteData: Array
  },
  data() {
    return {
    }
  },
  methods: {
    navChange(e) {
      this.$emit('update:selected', e)
    }
  },
};
</script>

<style scoped lang="less">
.Navbar{
    width: 100%;
    height: 0.5rem;
    line-height: 0.5rem;
    background: white;
    overflow: hidden;
    .Navbar-item{
        min-width: 16%;
        color: #999999;
        p{
            z-index: 2;
        }
        .item-line{
            width: 100%;
            height: 0.05rem;
            color: #333333;
            background: goldenrod;
            border-radius: 0.025rem;
            margin-top: -0.22rem;
            -webkit-animation: navShow 0.3s;
            animation: navShow 0.3s;
        }
    }
}
</style>
